import { useState , useRef } from 'react';

/* usefull when state needs to be accessed in async functions when state can change before function finishes */

export default ( defaultValue ) => {
    const [ normalState , setNormalState ] = useState(defaultValue);
    const refState = useRef();
    refState.current = normalState;
    return [ ()=>{ return refState.current ; } , (val)=>{  refState.current = val ; setNormalState(val);} ];
};